import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MyRoute from './MyRoute';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  root.render(
    <React.StrictMode>
      <MyRoute />
    </React.StrictMode>
  );
}

reportWebVitals();
